import { Component } from '@angular/core';
import { SkeletonComponent } from '../../../shared/skeleton/skeleton.component';

@Component({
  selector: 'app-ai-config-skeleton',
  templateUrl: './ai-config-skeleton.component.html',
  styleUrls: ['./ai-config-skeleton.component.scss'],
  imports: [SkeletonComponent],
})
export class AiConfigSkeletonComponent {
  readonly tabs = [1, 2];
  readonly summaryRows = [1, 2, 3, 4, 5, 6];
  readonly versionRows = [1, 2, 3, 4];
  readonly versionCols = [1, 2, 3, 4, 5];
}